import { Landing } from "./pages/Landing";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PanelesSolaresAdvise from "./pages/PanelesLandingPage";
import PanelesPrivacyPolicy from "./pages/PanelesPrivacyPolicy";
import useWindowWidth from "./interceptors/WidthChecker";
import ConvenioMarcoAdvise from "./pages/ConvenioMarcoLandingPage";
import ConvenioMarcoPrivacyPolicy from "./pages/ConvenioMarcoPrivacyPolicy";

function App() {

  const minNavbarWidth = 1150
  const width = useWindowWidth();
  const isLargeScreen = width > minNavbarWidth;

  return (
    <BrowserRouter>
        <Routes>
            <Route path="/" element={< Landing isLargeScreen={isLargeScreen}/>}></Route>
            <Route path="/SiGGER360" element={<PanelesSolaresAdvise isLargeScreen={isLargeScreen}/>}></Route>
            <Route path="/SiGGER360/privacyPolicy" element={<PanelesPrivacyPolicy/>}></Route>
            <Route path="/MSA" element={<ConvenioMarcoAdvise isLargeScreen={isLargeScreen}/>}></Route>
            <Route path="/MSA/privacyPolicy" element={<ConvenioMarcoPrivacyPolicy/>}></Route>
        </Routes>
    </BrowserRouter>
  );
}

export default App;
